import { Box, styled } from '@/shared/ui';

export const StyledChannelCard = styled('div')`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
`;

export const StyledCardHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  padding: 22px;
  font-size: 20px;
  font-weight: 500;
  line-height: 100%;
  border-radius: 20px 20px 0 0;
  gap: 8px;
`;

export const StyledCardBody = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 32px 60px;
  border: 1px solid ${({ theme }) => theme.palette.custom.grey6};
`;

export const StyledCardFooter = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 32px 60px;
  border: 1px solid ${({ theme }) => theme.palette.custom.grey6};
  border-radius: 0 0 20px 20px;
  margin-top: 3px;
`;

export const StyledFormBody = styled(Box)`
  width: 100%;
  margin-bottom: 14px;
  padding: 20px;
  background-color: #2c2d33;
  border-radius: 20px;
`;
